import { Avatar, Badge, Box, Typography } from "@mui/material";
import React from "react";
import Brightness1RoundedIcon from "@mui/icons-material/Brightness1Rounded";
import { borderColors } from "../../cssUtils/constants";

const BusinessProfileCard = ({ userProfileData }) => {
  console.log(userProfileData, "userProfileData");
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        border: 1,
        borderRadius: 2,
        paddingLeft: 1,
        paddingRight: 1,
        paddingY: 0.5,
        borderColor: borderColors.cardBorderPrimaryGrayColor,
      }}
    >
      <Avatar
        src={userProfileData.photo}
        sx={{
          width: 34,
          height: 34,
          border: 2,
          borderColor: "primary.main",
          cursor: "pointer",
          transition: "all 0.3s",
          "&:hover": {
            transform: "scale(1.05)",
          },
        }}
      >
        
      </Avatar>

      <Box>
        <Typography
          sx={{
            color: "#5A5A5A",
            fontWeight: "600",
            fontSize: "12px",
            lineHeight: "20px",
            marginBottom: "2px",
          }}
        >
          {userProfileData?.businessName}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Badge
            sx={{
              backgroundColor: "#009978",
              color: "#ffffff",
              borderRadius: 1,
              paddingX: "7px",
              paddingY: "1px",
              fontSize: "10px",
            }}
          >
            <Typography
              sx={{
                fontSize: "10px",
                lineHeight: "18px",
                textTransform: "uppercase",
              }}
            >
              {userProfileData?.plan}
            </Typography>
          </Badge>
          <Badge
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: "#A2A2A2",
            }}
          >
            {" "}
            <Brightness1RoundedIcon sx={{ height: "10px", width: "10px" }} />
            <Typography sx={{ fontSize: "12px", color: "#A2A2A2" }}>
              {""}
              {userProfileData?.userCount} users
            </Typography>
          </Badge>
        </Box>
      </Box>
    </Box>
  );
};

export default BusinessProfileCard;
